import { useState } from "react";
import { Plus } from "lucide-react";
import "./faq.css";

const faqs = [
  {
    q: "Is RAIN free?",
    /* The free plan on /pricing is open to anyone, not only students at
       partner schools — hence the middle sentence. */
    a: "There is a free plan for everyone: finding roles, tracking applications, networking and career exploration cost nothing, for as long as you like. If your school partners with RAIN, your career center covers the rest and you get the full platform. If it doesn’t, the AI tools are on our pricing page.",
  },
  {
    q: "How is RAIN different from a spreadsheet?",
    a: "It replaces the spreadsheet, the sticky notes, and the five open tabs with one plan. Applications, alumni outreach, interview prep, and your weekly to-dos live together, and RAIN tells you what to do next instead of leaving you to work it out at 1am.",
  },
  {
    q: "I don’t know what I want to do yet. Is it still useful?",
    a: "That’s the most common place people start. RAIN helps you explore directions, talk to alumni in fields you’re curious about, and narrow down before you commit to a search. You don’t need a target job title to get something out of it on day one.",
  },
  {
    q: "How does the networking piece work?",
    a: "RAIN finds alumni and other people worth knowing at the companies you’re targeting, tells you why each one is worth contacting, and drafts an opener you can edit. Every conversation, note, and follow-up stays attached to that person.",
  },
  {
    q: "Does my career center see what I’m doing?",
    /* Same split the career center page states in the AI block footnote —
       activity, not content. Change both together. */
    a: "Your advisors see your activity, including which roles you’ve applied to, the interviews and outreach you’ve logged, and how your search is progressing, so they know when to step in. They don’t see content: your notes, drafts, and messages stay yours.",
  },
  {
    q: "How long does it take to set up?",
    a: "A few minutes. You add your school, what you’re looking for, and where you are in the process, and RAIN builds your first week of tasks from there.",
  },
];


const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="s-section s-faq-section">
      <div className="home-container s-faq-grid">
        <div className="s-faq-head">
          <span className="s-eyebrow">Questions</span>
          <h2 className="s-faq-title">
            What job seekers
            <br />
            ask us first
          </h2>
          <p className="s-lead s-faq-sub">
            Still wondering something? Reach out at{" "}
            <a href="mailto:adminrain@raincareers.com">adminrain@raincareers.com</a>.
          </p>
        </div>

        <ul className="s-faq-list">
          {faqs.map(({ q, a }, i) => {
            const isOpen = i === open;
            return (
              <li key={q} className={`s-faq-item${isOpen ? " s-faq-item-open" : ""}`}>
                <button
                  type="button"
                  className="s-faq-q"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{q}</span>
                  <Plus size={18} strokeWidth={2} className="s-faq-icon" />
                </button>
                {/* Always mounted, collapsed to 0fr when closed — a mounted
                    element is what lets the open/close actually animate. */}
                <div className="s-faq-body" aria-hidden={!isOpen}>
                  <div className="s-faq-body-inner">
                    <p className="s-faq-a">{a}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Faq;
